import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import NoMatchComponent from '../../components/NoMatch'
import ProgramViewCont from '../../components/Project/Programs/ProgramsListViewCont'
import ProjectCont from '../../components/Project/Projects/ProjectCont'
import DashboardCont from '../../components/Project/Projects/DashboardCont'
import ProgramsDashboardCont from '../../components/Project/Programs/ProgramsDashboardCont'

export default class ProgramRouter extends Component {
  constructor(props) {
    super(props)
    this.url = props.match.url
  }

  render() {
    return (
      <Switch>
        <Route path={`${this.url}/:key/projects/:projectId/view`} component={DashboardCont} />
        <Route path={`${this.url}/:key/projects/list/`} component={ProjectCont} />
        <Route path={`${this.url}/:key/view`} component={ProgramsDashboardCont} />
        <Route path={`${this.url}/list`} component={ProgramViewCont} />
        <Route component={NoMatchComponent} />
      </Switch>
    )
  }
}
